@if (file().type | mimeTypeCheck: MIME_TYPES.PICTURE) {
    <img
        [ngSrc]="file() | getDirectusImage"
        [alt]="file().title"
        class="max-h-43 min-h-43 max-w-43 min-w-43 cursor-pointer rounded-lg object-fill transition-opacity hover:opacity-80 lg:max-h-68.5 lg:min-h-68.5 lg:max-w-68.5 lg:min-w-68.5"
        loading="lazy"
        decoding="async"
        tabindex="0"
        width="275"
        height="275"
        (click)="openLightbox()"
        (keydown.enter)="openLightbox()"
        (keydown.space)="openLightbox()"
    />
} @else if (file().type | mimeTypeCheck: MIME_TYPES.VIDEO) {
    <div class="relative">
        <video
            [src]="file() | getDirectusFile"
            class="max-h-43 min-h-43 max-w-43 min-w-43 cursor-pointer rounded-lg object-fill transition-opacity hover:opacity-80 lg:max-h-68.5 lg:min-h-68.5 lg:max-w-68.5 lg:min-w-68.5"
            tabindex="0"
            (click)="openLightbox()"
            (keydown.enter)="openLightbox()"
            (keydown.space)="openLightbox()"
        ></video>
        <div class="pointer-events-none absolute inset-0 flex items-center justify-center">
            <div class="relative">
                <div class="absolute inset-0 flex items-center justify-center">
                    <div class="flex size-10 items-center justify-center rounded-full bg-white">
                        <svg-icon
                            [svgStyle]="{ width: '60px', height: '60px' }"
                            src="assets/icons/Button-Play.svg"
                            class="text-primary drop-shadow-lg"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
}

@if (isLightboxOpen()) {
    <div
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm"
        tabindex="0"
        role="button"
        (click)="closeLightbox()"
    >
        <div
            class="flex flex-col items-center gap-4 p-4 lg:flex-row lg:gap-14"
            tabindex="0"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
        >
            @if (navigationState().hasPrevious) {
                <button
                    type="button"
                    class="text-primary z-10 hidden size-14 cursor-pointer rounded-full bg-white p-3 lg:block"
                    (click)="goToPrevious()"
                >
                    <svg-icon [svgStyle]="{ width: '32px', height: '32px' }" src="assets/icons/Arrow-Left-1.svg" />
                </button>
            }

            <div class="relative">
                @if (lightboxMediaType() === "image") {
                    <img
                        [ngSrc]="lightboxMediaSrc()"
                        [alt]="lightboxMediaAlt()"
                        width="1200"
                        height="600"
                        class="max-h-37.5 min-h-37.5 max-w-75 min-w-75 rounded-lg object-contain md:max-h-50 md:min-h-50 md:max-w-100 md:min-w-100 lg:max-h-75 lg:min-h-75 lg:max-w-150 lg:min-w-150 xl:max-h-100 xl:min-h-100 xl:max-w-200 xl:min-w-200 2xl:max-h-150 2xl:min-h-150 2xl:max-w-300 2xl:min-w-300"
                    />
                } @else if (lightboxMediaType() === "video") {
                    <video
                        [src]="lightboxMediaSrc()"
                        class="max-h-37.5 min-h-37.5 max-w-75 min-w-75 rounded-lg object-contain md:max-h-50 md:min-h-50 md:max-w-100 md:min-w-100 lg:max-h-75 lg:min-h-75 lg:max-w-150 lg:min-w-150 xl:max-h-100 xl:min-h-100 xl:max-w-200 xl:min-w-200 2xl:max-h-150 2xl:min-h-150 2xl:max-w-300 2xl:min-w-300"
                        controls
                        preload="metadata"
                        loading="lazy"
                    ></video>
                }
            </div>

            @if (navigationState().hasNext) {
                <button
                    type="button"
                    class="text-primary z-10 hidden size-14 cursor-pointer rounded-full bg-white p-3 lg:block"
                    (click)="goToNext()"
                >
                    <svg-icon [svgStyle]="{ width: '32px', height: '32px' }" src="assets/icons/Arrow-Right-1.svg" />
                </button>
            }

            <div class="mt-4 flex gap-4 lg:hidden">
                @if (navigationState().hasPrevious) {
                    <button
                        type="button"
                        class="text-primary z-10 size-12 cursor-pointer rounded-full bg-white p-3"
                        (click)="goToPrevious()"
                    >
                        <svg-icon [svgStyle]="{ width: '24px', height: '24px' }" src="assets/icons/Arrow-Left-1.svg" />
                    </button>
                }
                @if (navigationState().hasNext) {
                    <button
                        type="button"
                        class="text-primary z-10 size-12 cursor-pointer rounded-full bg-white p-3"
                        (click)="goToNext()"
                    >
                        <svg-icon [svgStyle]="{ width: '24px', height: '24px' }" src="assets/icons/Arrow-Right-1.svg" />
                    </button>
                }
            </div>

            <button
                (click)="closeLightbox()"
                class="text-primary absolute top-4 right-4 z-10 size-12 cursor-pointer rounded-full bg-white p-3 lg:top-9 lg:right-9"
            >
                <svg-icon [svgStyle]="{ width: '24px', height: '24px' }" src="assets/icons/Close.svg" />
            </button>
        </div>
    </div>
}
